// 페이지 안의 한 요소로 가는 스크롤. **앱의 스크롤 영역 하나만 움직인다**(#649).
//
// `scrollIntoView` 는 그 요소를 품은 스크롤 가능한 조상을 모두 움직인다 — `overflow: hidden` 인 셸과 문서까지다.
// 칸이 스크롤 영역의 끝 가까이 있으면 영역만으로는 그 칸을 가운데로 데려오지 못하고, 남은 거리만큼 셸이 밀려 올라가
// 상단 바가 잘리고 아래에 빈 띠가 생긴다. 그래서 요소가 스크롤 영역(`components/ui/scroll-area.tsx` 의 Viewport) 안이면
// 그 영역의 scrollTop 만 고친다. 영역 밖의 요소는 그대로 `scrollIntoView` 다.

const VIEWPORT = '[data-slot="scroll-area-viewport"]'

/** `el` 이 보이게 그 스크롤 영역을 움직인다 — `center` 는 가운데에, `start` 는 요소의 scroll-margin-top 만큼 띄운 위에. */
export function revealInPage(el: HTMLElement, block: 'center' | 'start', smooth = false): void {
  const behavior: ScrollBehavior = smooth ? 'smooth' : 'auto'
  const viewport = el.closest<HTMLElement>(VIEWPORT)
  if (!viewport) {
    el.scrollIntoView?.({ block, behavior })
    return
  }
  const box = viewport.getBoundingClientRect()
  const at = el.getBoundingClientRect()
  const offset = at.top - box.top + viewport.scrollTop
  const margin = Number.parseFloat(getComputedStyle(el).scrollMarginTop) || 0
  const top = block === 'center' ? offset - (viewport.clientHeight - at.height) / 2 : offset - margin
  viewport.scrollTo?.({ top: Math.max(0, top), behavior })
}
